<script>
import GovernoratesUpdateForm from "../components/GovernoratesUpdateForm.vue";
import GovernoratesDelete from "../components/GovernoratesDelete.vue";
export default {
  components: {
    GovernoratesUpdateForm,
    GovernoratesDelete,
  },
  props: {
    governoratesList: {
      default: [],
    },

    loading: {
      default: true,
    },
  },
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "Governorate En",
        value: "nameEn",
        sortable: false,
      },
      { text: "Governorate Ar", value: "nameAr", sortable: false },
      // { text: "Price", value: "price" },
      //  { text: "Days", value: "availableWeekdays" },
      { text: "Action", value: "actions", sortable: false },
    ],
  }),
};
</script>

<template>
  <div v-if="governoratesList != null" class="mt-n10">
    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="governoratesList" class="elevation-1 mt-10" :loading="loading">
      <template #item.name="{ item }">{{ item.nameEn }} {{ item.nameAr }}</template>
      <template v-slot:item.active="{ item }">
        <!-- <v-checkbox color="primary" disabled-color="primary" v-model="item.active" disabled></v-checkbox> -->
        <v-icon v-show="item.active" color="primary">mdi-checkbox-marked</v-icon>
        <v-icon v-show="!item.active" color="grey">mdi-checkbox-blank-outline</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row>
          <GovernoratesUpdateForm v-if="hasRole(AdminUserPermissions.LOCATION_EDIT)" :areaInfo="item" />
          <GovernoratesDelete v-if="hasRole(AdminUserPermissions.LOCATION_DELETE)" :area="item" />
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>
